import { AdvisorEntity } from "../../entities/advisor.entity";
import { AdvisorAction } from "./advisor.action";

export interface AdvisorState {
    customerAdvisor: AdvisorEntity;
    customerAdvisorError?: string;
    pending: boolean;
}

export const initialState: AdvisorState = {
    customerAdvisor: null,
    customerAdvisorError: null,
    pending: false,
};

export function AdvisorReducer(
    state: AdvisorState = initialState,
    action?: AdvisorAction
): AdvisorState {
    switch (action.type) {
        case AdvisorAction.getAdvisor: {
            return {
                ...state,
                ...{ pending: true }
            }
        }

        case AdvisorAction.getAdvisorSuccess: {
            return {
                ...state,
                ...{
                    pending: false,
                    customerAdvisor: action.payload,
                }
            }
        }

        case AdvisorAction.getAdvisorError: return {
            ...state,
            ...{
                pending: false,
                customerAdvisorError: action.payload,
            }
        }

        default:
            return state;
    }
}
